import React from "react";
import {
  AttachmentImage,
  GalleryRowWithModalProps,
  GalleryRowWithModal,
  Attachment3dModel,
} from "@msys/ui";
import { useTranslate } from "@tolgee/react";

export const GalleryRow = <I extends AttachmentImage | Attachment3dModel>(
  props: GalleryRowWithModalProps<I>
) => {
  const { t } = useTranslate("Global");
  return (
    <GalleryRowWithModal
      downloadTitle={t("Download")}
      addTitle={t("Add")}
      rotateTitle={t("Rotate")}
      deleteTitle={t("Delete")}
      arButtonTitle={t("View in your space")}
      {...props}
    />
  );
};
